// @flow
import React from 'react';

import { usePhase3Data } from 'client/hooks/usePhase3Data';
import { getCheckoutRoute } from 'routes/cart/util';
import { getAppSubType } from 'utils/common';
import CartPage from './CartPage';

const EdeCartDataLoader = (props: Object) => {
  const { personId, cartApps, hasFFMApp, productType, onExchange } = props;
  const productSubType = getAppSubType({ hasFFMApp, onExchange });
  const phase3Data = usePhase3Data(personId, productType, productSubType);
  const { isEnrolled } = phase3Data;
  const filteredCart = cartApps.filter(
    app => app.type !== 'health' || (!isEnrolled && app.type === 'health'),
  );
  const checkoutRoute = getCheckoutRoute(
    filteredCart,
    props.contentfulData,
    props.phase3Enabled,
    props.allowGaAccess,
  );

  return (
    <CartPage {...props} cartApps={filteredCart} checkoutRoute={checkoutRoute} {...phase3Data} />
  );
};

export default EdeCartDataLoader;
